export enum ApplicationServiceType {
    PURCHASE_INVOICE_MAPPING = 'purchase-invoice-mapping',
    PURCHASE_INVOICE_ROWS_DISTRIBUTE = 'purchase-invoice-rows-distribute',
}
